import { render, staticRenderFns } from "./actTransfer.vue?vue&type=template&id=3285bfb6&scoped=true&"
import script from "./actTransfer.vue?vue&type=script&lang=js&"
export * from "./actTransfer.vue?vue&type=script&lang=js&"
import style0 from "./actTransfer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./actTransfer.vue?vue&type=style&index=1&id=3285bfb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3285bfb6",
  null
  
)

component.options.__file = "actTransfer.vue"
export default component.exports